import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, combineLatest, from, map, Observable, startWith, Subject, switchMap, take } from 'rxjs';
import { RallyanceReclamationReclamatorPatchBody, RallyanceReclamationRekStatuses } from 'src/app/Interfaces/reclamations';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';
import { ReclamationService } from 'src/app/services/reclamation.service';
import { StoreService } from 'src/app/services/store.service';
import { TextService } from 'src/app/services/text.service';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
@Component({
	selector: 'app-reclamation-finish',
	templateUrl: './reclamation-finish.component.html',
	styleUrls: ['./reclamation-finish.component.scss'],
})
export class ReclamationFinishComponent implements OnInit, OnDestroy {
	_ss = inject(StoreService);
	_text = inject(TextService);
	_reclamation = inject(ReclamationService);
	private _fb = inject(FormBuilder);
	private _util = inject(UtilService);
	private _bottomPopup = inject(BottomPopupService);
	constructor() {}

	windowWidth = innerWidth;

	orderProcess = false;

	isSendingOrder = false;

	form = this._fb.nonNullable.group({
		RekRemark: [''],
		AhuzPizui: [''],
		ConfirmReason: [''],
		DOT: [''],
		SERIAL: [''],
		OmekSulia: [''],
		SugTakalatYazran: [''],
	});

	destroy$ = new Subject<void>();

	@ViewChild('imageInput') imageInput: ElementRef<HTMLInputElement>;

	selectedTask$ = this._reclamation.selectedTask$;
	rekID$ = this.selectedTask$.pipe(map(task => task?.RekID));
	clientName$ = this.selectedTask$.pipe(map(task => task?.Client_Name));
	productID$ = this.selectedTask$.pipe(map(task => task?.ProductId));
	productName$ = this.selectedTask$.pipe(map(task => task?.Product_Name));
	sugTakala$ = this.selectedTask$.pipe(map(task => task?.SugTakala));
	agentRemark$ = this.selectedTask$.pipe(map(task => task?.AgentRemark));
	agentDOT$ = this.selectedTask$.pipe(map(task => task?.DOT));

	statusesEnum = this._reclamation.rallyanceReclamationRekStatusesDictionary;

	shouldDisplaySentForClaimButtonAndShowSelectReason$ = this.selectedTask$.pipe(map(task => task?.RekStatus !== this.statusesEnum.sentForClaim));

	taskRekStatus$ = new BehaviorSubject<typeof RallyanceReclamationRekStatuses[number]>(this.statusesEnum.noStatus);
	isTaskPopupOpen$ = this.taskRekStatus$.pipe(map(status => status !== this.statusesEnum.noStatus));
	taskPopupTitle$ = this.taskRekStatus$.pipe(
		map(status => {
			switch (status) {
				case this.statusesEnum.notApproved:
					return 'לא מאושר';
				case this.statusesEnum.sentForClaim:
					return 'נשלח לתביעה';
				case this.statusesEnum.approved:
					return 'מאושר';
				default:
					return '';
			}
		}),
	);

	reclamationReasons$ = combineLatest([this._reclamation.sugRecReasons$.pipe(startWith(this._reclamation.sugRecReasons$.value)), this.taskRekStatus$]).pipe(
		map(([reasons, status]) => {
			return reasons.filter(reason => reason.Sug === this._reclamation.getSugStatusFromRekStatus(status));
		}),
	);

	taskPopupForApproved$ = this.taskRekStatus$.pipe(map(status => status === this.statusesEnum.approved));
	taskPopupForNotApproved$ = this.taskRekStatus$.pipe(map(status => status === this.statusesEnum.notApproved));
	taskPopupForSentForClaim$ = this.taskRekStatus$.pipe(map(status => status === this.statusesEnum.sentForClaim));

	readonly maxImages = 15;

	ngOnInit() {
		if (environment.development) {
			this.taskRekStatus$.next(this.statusesEnum.sentForClaim);
		}

		window.scrollTo(0, 0);

		if (!this._reclamation.selectedTask$.value) {
			alert('לא נבחרה תביעה');
			history.back();
			return;
		}

		this._reclamation.getReclamationReasons();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	BackToProducts() {
		history.back();
	}

	handleSaveOrBackButton() {
		this.BackToProducts();
	}

	handleSaveButton() {
		this.BackToProducts();
	}

	handleFormSubmit() {
		if (this.isSendingOrder) return;

		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}

		if (this._reclamation.imageUploadingQueue$.value.length) {
			this._bottomPopup.show('אנא המתן לסיום העלאת תמונות');
			return;
		}

		this.sendTask();
	}

	sendTask() {
		this.isSendingOrder = true;

		const body: RallyanceReclamationReclamatorPatchBody = {
			RekStatus: this.taskRekStatus$.value,
		};
		this.shouldDisplaySentForClaimButtonAndShowSelectReason$.pipe(take(1)).subscribe(shouldDisplay => {
			if (!shouldDisplay) {
				body.RekStatus = this.taskRekStatus$.value === this.statusesEnum.approved ? this.statusesEnum.ApprovedAFTERSentForClaim : this.statusesEnum.notApprovedAFTERSentForClaim;
			}
		});
		switch (this.taskRekStatus$.value) {
			case this.statusesEnum.notApproved:
				if (this.form.controls.RekRemark.value) {
					body.RekRemark = this.form.controls.RekRemark.value;
				}
				break;

			case this.statusesEnum.approved:
				if (this.form.controls.AhuzPizui.value) {
					body.AhuzPizui = this.form.controls.AhuzPizui.value;
				}
				body.ConfirmReason = this.form.controls.ConfirmReason.value;

				break;
			case this.statusesEnum.sentForClaim:
				body.DOT = this.form.controls.DOT.value || 'ERASED';
				body.SERIAL = this.form.controls.SERIAL.value || 'ERASED';
				body.SugTakalatYazran = this.form.controls.SugTakalatYazran.value;

				if (this.form.controls.OmekSulia.value) {
					body.OmekSulia = this.form.controls.OmekSulia.value;
				}
				const images = this._reclamation.uploadedImages$.value;
				for (const index in images) {
					const imageName = images[index];
					if (imageName) {
						body['PIC' + (Number(index) + 1)] = imageName;
					}
				}
				break;
			default:
				break;
		}

		this._reclamation.sendReclamationTaskAsReclamator(body, this.selectedTask$.value.TeudaNum).subscribe({
			next: res => {
				this.isSendingOrder = false;
				if (typeof res === 'string') {
					alert(this._text.store.couldntPatch);
					return;
				}
				this._reclamation.resetState();
				this.taskRekStatus$.next(this.statusesEnum.noStatus);
				this.orderProcess = true;
			},
			error: () => {
				alert(this._text.store.couldntPatch);
				this.isSendingOrder = false;
			},
		});
	}

	pipeADestroyer<T>(storeServiceMethod: Observable<T>) {
		return this._util.pipeASubjectDestoryer(storeServiceMethod, this.destroy$);
	}

	openTaskPopup(type: typeof RallyanceReclamationRekStatuses[number]) {
		this.taskRekStatus$.next(type);

		this.handleFormInit(type);
	}

	handleFormInit(type: typeof RallyanceReclamationRekStatuses[number]) {
		this.stripAllFormValidators();
		switch (type) {
			case this.statusesEnum.approved:
				this.shouldDisplaySentForClaimButtonAndShowSelectReason$.pipe(take(1)).subscribe(shouldDisplay => {
					if (shouldDisplay) {
						this.form.controls.ConfirmReason.setValidators(Validators.required);
					}
				});
				break;
			case this.statusesEnum.sentForClaim:
				this.form.controls.SugTakalatYazran.setValidators(Validators.required);
				break;

			default:
				break;
		}
	}

	stripAllFormValidators() {
		for (const key in this.form.controls) {
			this.form.controls[key].setValidators(null);
		}
	}

	handleClickOutsideTaskPopup(e: Event) {
		if ((e.target as HTMLElement).classList.contains('overlay')) {
			this.cancelSendAndClosePopup();
		}
	}

	cancelSendAndClosePopup() {
		this.taskRekStatus$.next(this.statusesEnum.noStatus);
		this.form.reset();
		this._reclamation.resetImages();
	}

	getButtonClass(color: string) {
		return { ['buttons-row-button-' + color]: true };
	}

	fillInputWithValue() {
		this.agentDOT$.pipe(take(1)).subscribe(value => {
			if (!value) return;
			this.form.controls.DOT.setValue(value);
		});
	}
}
